import { Route, Routes } from 'react-router'
import PurchaserDetails from './purchaserDetails'
import PurchasersTable from './purchasersTable'

export default () => (
    <Routes>
        <Route
            path=":purchaserId/*"
            element={<PurchaserDetails />}
        />
        <Route
            index
            element={<PurchasersTable />}
        />
    </Routes>
)
